export const AnimationDurationOptions = [
  0, 0.1, 0.25, 0.5, 1, 2, 3, 4, 5, 10, 15, 30,
];
